
export enum NavigatorType {
    Unknow = 0,
    Chrome = 1,
    Edge = 2,
    Firefox = 3,
    IE = 4,
}